<div class="login-page">
  <div *ngIf="showComponent === loginComponentScreen['Login']" class="login-box-container">
    <login #loginComponent [withNewEmail]="withNewEmail"></login>
  </div>
  <div *ngIf="showComponent === loginComponentScreen['Register']" class="login-box-container">
    <base-register #registerComponent [continueRegister]="continueRegister"></base-register>
  </div>
  <div *ngIf="showComponent === loginComponentScreen['Reset']" class="login-box-container">
    <base-reset-password #resetPasswordComponent></base-reset-password>
  </div>
</div>
